import { render, staticRenderFns } from "./VaultCategoryItem.vue?vue&type=template&id=290a1e81&scoped=true&"
import script from "./VaultCategoryItem.vue?vue&type=script&lang=ts&"
export * from "./VaultCategoryItem.vue?vue&type=script&lang=ts&"
import style0 from "./VaultCategoryItem.vue?vue&type=style&index=0&id=290a1e81&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290a1e81",
  null
  
)

export default component.exports